import React, { memo } from 'react'
import styled from 'styled-components'
import { ProjectCards } from './ProjectCards'
import { helperByProjectTemplateType, PROJECT_TEMPLATE_TYPE } from '../ProjectTemplateType'
import { Bubble } from '../../../components/Bubble'
import { Icon } from '@fluentui/react/lib/Icon'
import { ICON_NAMES } from '../../../common/src/msIcons'

const CloseButton = styled(Bubble)`
  position: absolute;
  top: 5px;
  left: 5px;
  right: auto;
  display: none;
  min-height: 20px;
  min-width: 20px;
  line-height: 8px;
  font-size: 8px;
`

const Container = styled.div`
  @media (hover: hover) and (pointer: fine) {
    &:hover ${CloseButton} {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`

export const ProjectTemplateCell = memo(
  ({ type = PROJECT_TEMPLATE_TYPE.CUSTOM, template, className, onDelete, ...rest }) => {
    const helper = helperByProjectTemplateType[type]
    const name = helper.getName(template)
    const notes = helper.getNotes(template)
    const localOnDelete = evt => {
      evt.stopPropagation()
      evt.preventDefault()
      onDelete(template)
    }
    return (
      <Container
        className={`box-border flex items-center px-2 py-3 text-sm text-pm-black hover:cursor-pointer hover:bg-pm-neutral-quaternary ${
          className ?? ''
        }`}
        {...rest}
      >
        {onDelete && (
          <CloseButton onClick={localOnDelete}>
            <Icon iconName={ICON_NAMES.ChromeClose} />
          </CloseButton>
        )}
        <ProjectCards type={type} template={template} className="mr-3" />
        <div className="flex flex-1 flex-col">
          <div className="flex-1 font-semibold">{name}</div>
          {notes && <div className="line-clamp-2 flex-1">{notes}</div>}
        </div>
      </Container>
    )
  }
)
